import { MinusCircleOutlined } from "@ant-design/icons";
import {
    Button,
    Checkbox,
    Col,
    Form,
    Input,
    notification,
    Row,
    Select,
} from "antd";
import Modal from "antd/lib/modal/Modal";
import React, { useEffect } from "react";
import HTTP from "../../services/httpService";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;

const AddEditAlarm = ({
    record,
    visible,
    onClose,
    hotels,
    alarmPriority,
    alarmType,
}) => {
    const [form] = Form.useForm();

    const {
        alarm_name,
        priority,
        alarm_send_to_email,
        alarm_send_to_phone,
        alarm_email_ids,
        alarm_phone_numbers,
        alarm_hotel_ids,
        alarm_type,
    } = record;

    useEffect(() => {
        form.setFieldsValue({
            alarm_name,
            priority,
            alarm_send_to_email,
            alarm_send_to_phone,
            alarm_email_ids,
            alarm_phone_numbers,
            alarm_hotel_ids,
            alarm_type,
        });
    }, [record]);

    const handleSubmit = (values) => {
        values.staff_id = record.staff_id;
        if (record.id) {
            values.id = record.id;
            editAlarm(values);
        } else {
            addAlarm(values);
        }
    };

    const editAlarm = async (formData) => {
        const { success, message } = await HTTP("/alarms/editAlarm", formData);
        onClose();
        if (success === 0) {
            notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: message,
            });
        }
    };

    const addAlarm = async (formData) => {
        const { success, message } = await HTTP("/alarms/addAlarm", formData);
        onClose();
        if (success === 0) {
            notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: message,
            });
        }
    };

    const phoneNumbers = (
        <Form.List name="alarm_phone_numbers">
            {(fields, { add, remove }) => {
                if (!fields.length) add();
                return (
                    <>
                        {fields.map((field, index) => (
                            <Form.Item
                                key={field.key}
                                label={index === 0 ? "Phone Numbers" : ""}
                                style={{ margin: 0, justifyContent: "end" }}
                            >
                                <Row>
                                    <Col xs={20}>
                                        <Form.Item {...field}>
                                            <PhoneInput placeholder="Phone number" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={4}>
                                        {fields.length > 1 && (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() =>
                                                    remove(field.name)
                                                }
                                            />
                                        )}
                                    </Col>
                                </Row>
                            </Form.Item>
                        ))}
                        <Form.Item noStyle>
                            <Button
                                style={{ marginBottom: 30 }}
                                onClick={() => add()}
                            >
                                Add
                            </Button>
                        </Form.Item>
                    </>
                );
            }}
        </Form.List>
    );

    const emails = (
        <Form.List name="alarm_email_ids">
            {(fields, { add, remove }) => {
                if (!fields.length) add();
                return (
                    <>
                        {fields.map((field, index) => (
                            <Form.Item
                                key={field.key}
                                label={index === 0 ? "Emails" : ""}
                                style={{ margin: 0, justifyContent: "end" }}
                                required
                            >
                                <Row>
                                    <Col xs={20}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Please enter Email!",
                                                },
                                                {
                                                    type: "email",
                                                    message:
                                                        "The input is not valid E-mail!",
                                                },
                                            ]}
                                            {...field}
                                        >
                                            <Input
                                                type="email"
                                                placeholder="Email"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={4}>
                                        {fields.length > 1 && (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() =>
                                                    remove(field.name)
                                                }
                                            />
                                        )}
                                    </Col>
                                </Row>
                            </Form.Item>
                        ))}
                        <Form.Item>
                            <Button onClick={() => add()}>Add</Button>
                        </Form.Item>
                    </>
                );
            }}
        </Form.List>
    );

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            destroyOnClose
            title={record.id ? "Edit" : "Add"}
            footer=""
            afterClose={() => form.resetFields()}
        >
            <Form
                form={form}
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="alarm_name"
                    label="Alarm name"
                    rules={[{ required: true, message: "Name is required!" }]}
                >
                    <Input placeholder="Alarm name" />
                </Form.Item>

                <Form.Item
                    name="alarm_hotel_ids"
                    label="Hotels"
                    rules={[
                        { required: true, message: "Please select hotel!" },
                    ]}
                >
                    <Select
                        placeholder="Hotel name"
                        mode="multiple"
                        showSearch
                        allowClear
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {hotels.data.map((hotel) => (
                            <Option
                                key={`${hotel.hotel_name}#${hotel.hotel_id}`}
                                value={hotel.hotel_id}
                            >
                                {`${hotel.hotel_id} -${hotel.hotel_name} - ${hotel.city}`}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item name="priority" label="Priority">
                    <Select>
                        {alarmPriority.map((item) => (
                            <Option value={item.value} key={item.value}>
                                {item.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Alarm type"
                    name="alarm_type"
                    rules={[
                        {
                            required: true,
                            message: "Please Select alarm type!",
                        },
                    ]}
                >
                    <CheckboxGroup>
                        <Row>
                            {alarmType.map((e) => (
                                <Col
                                    xs={24}
                                    style={{ marginBottom: 16 }}
                                    key={e.key}
                                >
                                    <Checkbox key={e.key} value={e.key}>
                                        {e.title}
                                    </Checkbox>
                                </Col>
                            ))}
                        </Row>
                    </CheckboxGroup>
                </Form.Item>

                <Form.Item
                    name="alarm_send_to_email"
                    label="Send to Email"
                    valuePropName="checked"
                >
                    <Checkbox />
                </Form.Item>

                <Form.Item
                    name="alarm_send_to_phone"
                    label="Send to Phone"
                    valuePropName="checked"
                >
                    <Checkbox />
                </Form.Item>
                {phoneNumbers}
                {emails}
                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddEditAlarm;
